import * as FirebaseAuth from "firebase/auth";
import * as FirebaseFirestore from "firebase/firestore";
import * as FirebaseStorage from "firebase/storage";
import { initializedFirebaseApp } from "./init";

const app = initializedFirebaseApp;

// Export initialized instances
export const auth = FirebaseAuth.getAuth(app);
auth.languageCode = "es";

// Lock in the most durable session strategy explicitly. The SDK default is the
// same today, but phone-only accounts have no password — every re-auth costs an
// SMS, so we never want to lose the session to a future SDK default change.
// Fire-and-forget: in restricted environments (Safari private mode, disabled
// IndexedDB) the SDK falls back to in-memory automatically.
FirebaseAuth.setPersistence(auth, FirebaseAuth.browserLocalPersistence).catch(
  (error) => {
    console.warn(
      "Failed to set Firebase Auth persistence; falling back to SDK default.",
      error,
    );
  },
);
export const firestore = FirebaseFirestore.getFirestore(app);
export const storage = FirebaseStorage.getStorage(app);

const useEmulators = process.env.EXPO_PUBLIC_USE_FIREBASE_EMULATORS === "true";

if (useEmulators) {
  const emulatorHost =
    process.env.EXPO_PUBLIC_FIREBASE_EMULATOR_HOST || "127.0.0.1";
  const authPort = Number(
    process.env.EXPO_PUBLIC_FIREBASE_AUTH_EMULATOR_PORT || 9099,
  );
  const firestorePort = Number(
    process.env.EXPO_PUBLIC_FIREBASE_FIRESTORE_EMULATOR_PORT || 8080,
  );
  const storagePort = Number(
    process.env.EXPO_PUBLIC_FIREBASE_STORAGE_EMULATOR_PORT || 9199,
  );

  FirebaseAuth.connectAuthEmulator(auth, `http://${emulatorHost}:${authPort}`, {
    disableWarnings: true,
  });
  FirebaseFirestore.connectFirestoreEmulator(
    firestore,
    emulatorHost,
    firestorePort,
  );
  FirebaseStorage.connectStorageEmulator(storage, emulatorHost, storagePort);
}

// Export all v9 modular functions and types directly as part of the respective module
export { FirebaseAuth, FirebaseFirestore, FirebaseStorage };

export const firestoreDoc = (ref: any, path: string) => {
  return FirebaseFirestore.doc(ref, path);
};

export const firestoreSetDoc = (docRef: any, data: any, options?: any) => {
  return FirebaseFirestore.setDoc(docRef, data, options);
};

// Type export
export type User = import("firebase/auth").User;
export type DocumentSnapshot = import("firebase/firestore").DocumentSnapshot;
